<template>
  <div>
    <ad-drawer
      :showBtn="true"
      :visible.sync="addVideoByUrlShow"
      :configDraw="configDraw"
      @sure="sure"
      @close="cancel"
    >
      <el-input
        v-model.trim="videoUrl"
        @keyup.enter.native="getVideoId"
        @blur="getVideoId"
        placeholder="请输入youtube视频链接，回车查找视频"
      ></el-input>
      <el-row
        :gutter="20"
        class="w-full mt-2"
        align="middle"
        justify="space-between"
      >
        <el-col
          :span="6"
          class="py-3 text-center font-bold text-[14px]"
        >
          视频
        </el-col>
        <el-col
          :span="16"
          class="py-3 text-center font-bold text-[14px]"
        >
          视频标题
        </el-col>
        <el-col
          :span="2"
          class="py-3 text-center font-bold text-[14px]"
        >
          操作
        </el-col>
      </el-row>
      <div class="p-2">
        <div
          v-for="(video, index) in videoList"
          :key="video.tempKey || video.videoId"
        >
          <AddVideoItem
            :video="video"
            :index="index"
            @deleteVideo="deleteVideo"
            :class="['border', 'mb-2', video.status == 'error' ? '!border-danger' : '']"
          />
          <p
            class="text-danger"
            v-if="video.status == 'error'"
          >
            {{ video.errorMsg || '无法解析该视频。私密视频请改为「不公开列出」，或用「youtube选择」从已授权频道添加' }}
          </p>
        </div>
      </div>
    </ad-drawer>
  </div>
</template>
<script>
import { adDrawer } from '@adCommonComponent';
import AddVideoItem from '../AddVideoItem/index.vue';
import { getYoutubeVideoId, getYoutubeThumbnail } from '@/utils/youtubeVideoInfo';
import { parseVideoByUrl } from '@/api/google/youtube';

let tempKeySeq = 0;

export default {
  components: { adDrawer, AddVideoItem },
  props: {
    addVideoByUrlShow: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      configDraw: {
        title: '添加视频',
        size: '1200px',
        'append-to-body': true,
      },
      videoUrl: '',
      videoList: [],
    };
  },
  methods: {
    async getVideoId() {
      const input = (this.videoUrl || '').trim();
      if (!input) return;

      const localVideoId = getYoutubeVideoId(input);
      if (localVideoId && this.videoList.find((v) => v.videoId === localVideoId)) {
        this.videoUrl = '';
        return;
      }

      const tempKey = `pending_${Date.now()}_${++tempKeySeq}`;
      this.videoList.push({
        tempKey,
        videoId: localVideoId || '',
        videoTitle: '',
        videoName: '',
        thumbnailUrl: localVideoId ? getYoutubeThumbnail(localVideoId) : '',
        duration: null,
        privacyStatus: '',
        youtubeVideoUrl: '',
        status: 'loading',
        errorMsg: '',
      });
      this.videoUrl = '';

      try {
        const res = await parseVideoByUrl({ videoUrl: input });
        if (res.code !== 0 || !res.data) {
          this.updateVideoByTempKey(tempKey, {
            status: 'error',
            errorMsg: res.comment || '无法解析该视频',
          });
          return;
        }

        const data = res.data;
        if (data.videoId && this.videoList.some((v) => v.tempKey !== tempKey && v.videoId === data.videoId)) {
          this.removeByTempKey(tempKey);
          this.$message.warning('该视频已添加');
          return;
        }

        this.updateVideoByTempKey(tempKey, {
          tempKey: undefined,
          videoId: data.videoId,
          videoTitle: data.title || '',
          videoName: data.title || '',
          thumbnailUrl: data.thumbnail || (data.videoId ? getYoutubeThumbnail(data.videoId) : ''),
          duration: data.duration,
          privacyStatus: data.privacyStatus || '',
          youtubeVideoUrl: data.youtubeVideoUrl || '',
          status: data.title ? 'success' : 'error',
          errorMsg: data.title
            ? ''
            : '无法解析该视频。私密视频请改为「不公开列出」，或用「youtube选择」从已授权频道添加',
        });
      } catch (e) {
        this.updateVideoByTempKey(tempKey, {
          status: 'error',
          errorMsg: (e && (e.msg || e.comment || e.message)) || '解析失败，请稍后重试',
        });
      }
    },
    updateVideoByTempKey(tempKey, payload) {
      const index = this.videoList.findIndex((v) => v.tempKey === tempKey);
      if (index < 0) return;
      const next = { ...this.videoList[index], ...payload };
      if (Object.prototype.hasOwnProperty.call(payload, 'tempKey') && payload.tempKey === undefined) {
        delete next.tempKey;
      }
      this.$set(this.videoList, index, next);
    },
    removeByTempKey(tempKey) {
      const index = this.videoList.findIndex((v) => v.tempKey === tempKey);
      if (index >= 0) this.videoList.splice(index, 1);
    },
    deleteVideo(index) {
      this.videoList.splice(index, 1);
    },
    closeDrawer() {
      this.videoList = [];
      this.$emit('update:addVideoByUrlShow', false);
    },
    cancel() {
      this.closeDrawer();
    },
    sure() {
      if (this.videoList.some((v) => v.status === 'loading')) {
        this.$message.warning('视频信息正在解析，请稍候');
        return;
      }
      this.videoList.forEach((v) => {
        if (!v.videoTitle) {
          v.status = 'error';
          if (!v.errorMsg) {
            v.errorMsg =
              '无法解析该视频。私密视频请改为「不公开列出」，或用「youtube选择」从已授权频道添加';
          }
        } else {
          v.status = 'success';
          v.errorMsg = '';
        }
      });
      if (this.videoList.some((v) => v.status == 'error')) {
        return;
      }
      this.$emit('getVideoList', this.videoList, 'getByUrl');
      this.closeDrawer();
    },
  },
};
</script>
